<div class="settings-dialog">
  <h1 mat-dialog-title>Einstellungen</h1>
  <mat-dialog-content>
    <h3 class="section-title">Benachrichtigungen</h3>
    <p class="gray hint">
      Wählen Sie für jede Benachrichtigung, ob sie in der Anwendung angezeigt und ob sie per E-Mail gesendet wird.
      Änderungen werden sofort gespeichert.
    </p>
    @if (loading) {
      <div class="center-content pad16">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else {
      <table [dataSource]="settings" class="w100 settings-table" mat-table>
        <ng-container matColumnDef="label">
          <th *matHeaderCellDef mat-header-cell>Benachrichtigung</th>
          <td *matCellDef="let setting" mat-cell>{{ setting.label }}</td>
        </ng-container>
        <ng-container matColumnDef="inApp">
          <th *matHeaderCellDef class="toggle-cell" mat-header-cell>In der App</th>
          <td *matCellDef="let setting" class="toggle-cell" mat-cell>
            <mat-slide-toggle (change)="toggle(setting, 'inApp', $event.checked)"
                              [attr.aria-label]="setting.label + ': in der App'"
                              [checked]="setting.inApp" color="primary"></mat-slide-toggle>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th *matHeaderCellDef class="toggle-cell" mat-header-cell>E-Mail</th>
          <td *matCellDef="let setting" class="toggle-cell" mat-cell>
            <mat-slide-toggle (change)="toggle(setting, 'email', $event.checked)"
                              [attr.aria-label]="setting.label + ': E-Mail'"
                              [checked]="setting.email" color="primary"></mat-slide-toggle>
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
      </table>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <a mat-button mat-dialog-close routerLink="/benachrichtigungen">
      <mat-icon>notifications</mat-icon>
      Benachrichtigungen anzeigen
    </a>
    <button cdkFocusInitial mat-dialog-close mat-raised-button>Schließen</button>
  </mat-dialog-actions>
</div>
